import useWatcher from "../../useWatcher";
import useAddEvent from "../core/useAddEvent";
import { isEqual } from "../core/util";

const select = (name, props, node) => {



    const { onCreated, onDestroy, onPropChanges } = useWatcher(props, node, [name]);

    let detachEvent;
    const attachEvent = () => {
        detachEvent = useAddEvent(['change'], node, (e) => {
            const value = e.target.value;
            if (!isEqual(props[name], value)) {
                props[name] = node.value;
            }
        })
    }

    onCreated(() => {
        if (typeof props[name] === 'string' && props[name] !== node.value) {
            // setTimeout(() => {
                node.value = props[name];
            // },100);
        }
        attachEvent();
    });

    onPropChanges(() => {
        if (!isEqual(props[name], node.value)) {
            node.value = props[name];
        }
    })

    onDestroy(() => {
        if (typeof detachEvent === 'function') {
            detachEvent();
        }
    })
}

export default select;